module.exports = __webpack_public_path__ + "img/Dealings.d59ec389.svg";